/* models/layouts/spacer */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var layout_dom_1 = require(166) /* ./layout_dom */;
    var layout_1 = require(13) /* ../../core/layout */;
    var SpacerView = /** @class */ (function (_super) {
        tslib_1.__extends(SpacerView, _super);
        function SpacerView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(SpacerView.prototype, "child_models", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        SpacerView.prototype._update_layout = function () {
            this.layout = new layout_1.LayoutItem();
            this.layout.set_sizing(this.box_sizing());
        };
        SpacerView.__name__ = "SpacerView";
        return SpacerView;
    }(layout_dom_1.LayoutDOMView));
    exports.SpacerView = SpacerView;
    var Spacer = /** @class */ (function (_super) {
        tslib_1.__extends(Spacer, _super);
        function Spacer(attrs) {
            return _super.call(this, attrs) || this;
        }
        Spacer.initClass = function () {
            this.prototype.default_view = SpacerView;
        };
        Spacer.__name__ = "Spacer";
        return Spacer;
    }(layout_dom_1.LayoutDOM));
    exports.Spacer = Spacer;
    Spacer.initClass();
}
